var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('SearchableList',{attrs:{"section":"activities","per-page":20}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header"},[_c('h1',{staticClass:"section-header__title"},[_vm._v("Activities")]),_vm._v(" "),_c('p',{staticClass:"section-header__subtitle"},[_vm._v("Restaurants, bars, nightlife & experiences")])])
}]

export { render, staticRenderFns }